skrilla.controller('lolMatchDetailsCtrl', function ($scope, searchService, $stateParams, modalService, objectChangeService, cacheService, srefService, adminService) {
    $scope.hasRole = adminService.hasRole;
    $scope.key = "lolMatchDetails";
    $scope.hasChanged = objectChangeService.hasValueChanged;
    cacheService.registerObject("contestSport", "lol");

    $scope.positions = [
        "TOP",
        "JUNGLER",
        "MID",
        "ADC",
        "SUPPORT",
        "FLEX",
        "SUB"
    ];
    $scope.states = [
        "PENDING",
        "LIVE",
        "ENDED",
        "COMPLETED",
        "VERIFIED",
        "CANCELLED"
    ];


  $scope.getData = function() {
    searchService.get('lol/matches/' + $stateParams.id).then(function (response) {
      $scope.match = response.data;
      $scope.newSource = $scope.match.sourceId;
      cacheService.registerObject($scope.key, $scope.match);
      objectChangeService.registerObject($scope.key, "match", $scope);
    });
  }

    $scope.getData()

    $scope.positionChanged = function(player){
        player.hasChanged = true;
    }

    $scope.savePosition = function(player){
        searchService.put('players/lol/' + player.playerId + '/position/' + player.position, null, "Player position successfully updated!").then(function(response){
            player.hasChanged = false;
            objectChangeService.registerObject($scope.key, "match", $scope);
        });
    }

    $scope.changed = function(player){
      modalService.confirm("Are you sure you'd like to change this player's active status?", function(){
        var method = player.playerActive === "true" ? "post" : "deleteRequest";
        searchService[method]("players/lol/" + player.playerId + "/active").then(function(response){
            objectChangeService.registerObject($scope.key, "match", $scope);
        });
      });

    }

    $scope.editTeamScores = function(team){
        cacheService.registerObject("updateLoLTeam", team);
        modalService.openModal("views/manualUpdateLoLTeamScores/manualUpdateLoLTeamScores.html", true, 'lg', true, true);
    }

    $scope.editPlayerScores = function(player){
        cacheService.registerObject("updateLoLPlayer", player);
        modalService.openModal("views/manualUpdateLoLPlayerScores/manualUpdateLoLPlayerScores.html", true, 'lg', true, true);
    }

    $scope.pollData = function(){
        modalService.confirm("Are you sure you'd like to start polling for this data?", function(){
            searchService.post('lol/matches/' + $stateParams.id + '/start')
        });
    }
  $scope.removeMatch = function(){
    modalService.confirm("Are you sure you'd like to remove this match?", function(){
      searchService.put('lol/matches/' + $stateParams.id + '/remove')
    });
  }
  $scope.startMatch = function(){
    modalService.confirm("Are you sure you'd like to start this match?", function(){
      searchService.put('lol/matches/' + $stateParams.id + '/scheduledStartTime', {
        "startNow":true
      })
    });
  }

    $scope.createTeams = function(){
        modalService.confirm("Are you sure you'd like to create teams for this match?", function(){
            searchService.put('lol/matches/' + $stateParams.id + '/teams', {}, "Teams successfully created").then(function(response){
                $scope.getData()
            })
        });
    }

    $scope.reloadData = function(){
      modalService.confirm("Are you sure you'd like to reload data for this match?", function(){
            modalService.openLoadingModal();
            searchService.post('lol/matches/reloadMatchData', {"matchIds": [$stateParams.id]}, "Match data reloaded").then( function(response) {
                $scope.match = response.data[0];
                modalService.closeLoadingModal();
            });
        });
    }

    $scope.updateUris = function(){
        modalService.openModal("views/updateLoLStreamUrisModal/updateLoLStreamUrisModal.html", true, 'lg', true, true, function(){
            objectChangeService.registerObject($scope.key, "match", $scope);
            cacheService.registerObject($scope.key, $scope.match);
        });
    }

    $scope.cancel = function(){
        modalService.confirm("Are you sure you'd like to cancel this match?", function(){
            searchService.put('lol/matches/' + $stateParams.id + "/cancel", {}, "Match successfully cancelled").then(function(response){
                $scope.match.state = "CANCELLED";
                objectChangeService.registerObject($scope.key, "match", $scope);
            });
        });
    }

    $scope.saveScores = function(){
        var data = {matchId: $scope.match.id, matchState: $scope.newState, teamScores: {}, teamMemberScores :{}};
        $scope.match.teams.forEach(function(team){
            data.teamScores[team.id] = team;
            team.members.forEach(function(member){
                data.teamMemberScores[member.id] = member;
            })
        });
        searchService.put("lol/matches/"  + $stateParams.id + "/updateScores", data, "Scores successfully updated").then(function(response){
            objectChangeService.registerObject($scope.key, "match", $scope);
        });
    }

    $scope.isEditable = function(){
        return $scope.match;
    }

    $scope.reassign = function(){
        modalService.openModal("views/reassignLoLMatchModal/reassignLoLMatchModal.html", true, 'lg', true, true, function(){
            objectChangeService.registerObject($scope.key, "match", $scope);
        });
    }

    $scope.deleteTeam = function(team){
        modalService.confirm("Are you sure you'd like to delete this team?", function(){
            searchService.deleteRequest("lol/matches/"  + $stateParams.id + "/teams/" + team.id, "Team successfully deleted!").then(function(){
                $scope.match.teams = $scope.match.teams.filter(function(t){return t.id !== team.id});
                objectChangeService.registerObject($scope.key, "match", $scope);
            });
        })
    }


    $scope.openPlayerModal = function(player) {
      player.sport = 'lol';
        cacheService.registerObject("player", player)
        modalService.openModal('views/playerModal/playerModal.html', true, 'lg', true, true, function () {
          $scope.getData()
        });
    }

});

